import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider, useIsMutating } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { BusyProvider, ToastProvider } from '@fos/ui';
import '@fos/ui/fonts.css';
import '@fos/ui/styles.css';
import './app.css';
import './lib/i18n';
import { isFailure } from './lib/api';
import { createAppRouter } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, e) => !isFailure(e) || (e.status >= 500 && count < 2),
    },
  },
});
const router = createAppRouter(queryClient);

/** Writes in progress, for the loading of the clicked button (BusyProvider in @fos/ui). */
function Busy({ children }: { children: ReactNode }) {
  return <BusyProvider count={useIsMutating()}>{children}</BusyProvider>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Busy>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </Busy>
    </QueryClientProvider>
  </StrictMode>,
);
